import { Model } from '@appstrax/services/database';

export type NotificationCategory = 'system' | 'mention' | 'general' | 'invite';

export class AppNotification extends Model {
  public toUserId: string = '';
  public title: string = '';
  public message: string = '';
  public category: NotificationCategory = 'general';
  public read: boolean = false;
  public archived: boolean = false;
  public timestamp: number = Date.now();

  // Optional metadata (linking, extra payload)
  public data?: any;
}

